export const TOGGLECLICK = 'TOGGLECLICK';
export const SETACTIVETAB = 'SETACTIVETAB';
export const SETLOADING = 'SETLOADING';
